

import { Component, Mixins } from "vue-property-decorator";
import DateOperations from "@/mixins/date/date-operations";
import ListSorterByDateField from "@/mixins/sort/list-sorter-by-date-field";
import IBNotificationReadDOM from "@/components/Notification/IBNotificationReadDOM";

@Component
export default class IBNotificationContent extends Mixins(
	DateOperations,
	ListSorterByDateField,
	IBNotificationReadDOM
) {}

